var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8333 15.625C17.9569 15.625 15.625 17.9569 15.625 20.8333V79.1667C15.625 82.0431 17.9569 84.375 20.8333 84.375H79.1667C82.0431 84.375 84.375 82.0431 84.375 79.1667V20.8333C84.375 17.9569 82.0431 15.625 79.1667 15.625H20.8333ZM9.375 20.8333C9.375 14.5051 14.5051 9.375 20.8333 9.375H79.1667C85.4949 9.375 90.625 14.5051 90.625 20.8333V79.1667C90.625 85.4949 85.4949 90.625 79.1667 90.625H20.8333C14.5051 90.625 9.375 85.4949 9.375 79.1667V20.8333Z",
    fill: "#A5AEBC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4569 39.4563C65.6773 38.2359 67.6559 38.2359 68.8763 39.4563L89.7096 60.2896C90.93 61.51 90.93 63.4887 89.7096 64.7091C88.4892 65.9294 86.5106 65.9294 85.2902 64.7091L66.6666 46.0854L23.043 89.7091C21.8226 90.9294 19.8439 90.9294 18.6235 89.7091C17.4032 88.4887 17.4032 86.51 18.6235 85.2896L64.4569 39.4563Z",
    fill: "#A5AEBC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4167 32.291C33.6909 32.291 32.2917 33.6901 32.2917 35.416C32.2917 37.1419 33.6909 38.541 35.4167 38.541C37.1426 38.541 38.5417 37.1419 38.5417 35.416C38.5417 33.6901 37.1426 32.291 35.4167 32.291ZM26.0417 35.416C26.0417 30.2383 30.2391 26.041 35.4167 26.041C40.5944 26.041 44.7917 30.2383 44.7917 35.416C44.7917 40.5937 40.5944 44.791 35.4167 44.791C30.2391 44.791 26.0417 40.5937 26.0417 35.416Z",
    fill: "#A5AEBC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyImg);
export default __webpack_public_path__ + "static/media/empty_img.87635f4ef335801c190c6ea1f312c3c3.svg";
export { ForwardRef as ReactComponent };